import { STATS } from "@/data/content";
import useCountUp from "@/hooks/useCountUp";

function Stat({ value, suffix, label }) {
  const { ref, value: n } = useCountUp(value);
  return (
    <div ref={ref} className="text-center" data-testid="stat-counter">
      <p className="font-heading text-4xl md:text-5xl font-medium text-primary tracking-tight">
        {n}
        <span className="text-emerald-600">{suffix}</span>
      </p>
      <p className="mt-2 text-sm text-foreground/60 font-medium">{label}</p>
    </div>
  );
}

export default function Stats() {
  return (
    <section className="py-16 bg-background border-y border-border" data-testid="stats-section">
      <div className="max-w-6xl mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-10">
        {STATS.map((s) => (
          <Stat key={s.label} {...s} />
        ))}
      </div>
    </section>
  );
}
